import { formatRelative } from 'date-fns'
import locales from 'utils/dateFns/locales'
import PropTypes from 'prop-types'

const formatRelativeFunction = (date, formatStr = 'PP', options = {}) => {
  const formatRelativeLocale = {
    lastWeek: formatStr,
    nextWeek: "dddd 'um' LT",
    other: formatStr,
    ...options,
  }

  if (!global || (global && !global.__localeId__)) {
    return null
  }

  return formatRelative(date, new Date(), {
    locale: {
      ...locales[global.__localeId__],
      formatRelative: (token) => formatRelativeLocale[token],
    },
  })
}

formatRelativeFunction.propTypes = {
  date: PropTypes.string,
  formatStr: PropTypes.string,
  options: PropTypes.object,
}

export default formatRelativeFunction
